// extracted by mini-css-extract-plugin
export const contactContainer = "contact-module--contactContainer--NgpHE";
export const generalInquiriesHeading = "contact-module--generalInquiriesHeading--1DShJ";
export const onceHubEmbed = "contact-module--onceHubEmbed--26opT";